import { formatIntToCurrency } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import type { ProductReport } from "~/managers/use-register-manager";
import type { ColumnDefWithTotal } from "~/types";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { api } from "~/lib/api";
import { useReportStore } from "~/stores/use-report-store";

export const Route = createFileRoute("/_main/reports/_layout/product")({
  component: ProductReports,
});

function ProductReports() {
  const { range } = useReportStore();

  const { t } = useTranslation("common");

  const { data } = api.report.getProductReports.useQuery(
    {
      startDate: range.from,
      endDate: range.to,
    },
    {
      initialData: [],
      staleTime: 0,
    },
  );

  let filename = `product-sales-report`;
  let title = `Product sales report`;

  if (range.from) {
    filename += `_${format(range.from, "P")}`;
    title += ` ${format(range.from, "P")}`;
    if (range.to) {
      filename += `-${format(range.to, "P")}`;
      title += ` - ${format(range.to, "P")}`;
    }
  }

  const columns: ColumnDefWithTotal<ProductReport>[] = [
    {
      id: t("Report.name"),
      accessorKey: "productName",
      filterFn: "includesString",
      size: 20,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Report.name")} />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{report.productName}</p>;
      },
    },
    {
      id: t("Report.Product.items_sold"),
      accessorKey: "itemsSold",
      filterFn: "includesString",
      size: 10,
      enableTotal: true,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Report.Product.items_sold")}
        />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{report.itemsSold}</p>;
      },
    },
    {
      id: t("Report.revenue"),
      accessorKey: "revenue",
      filterFn: "includesString",
      size: 10,
      enableTotal: true,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Report.revenue")} />
      ),
      cell: ({ row: { original: report } }) => {
        return <p>{formatIntToCurrency(report.revenue, true)}</p>;
      },
    },
    // {
    //   id: t("Report.vat"),
    //   accessorKey: "vat",
    //   filterFn: "includesString",
    //   size: 10,
    //   enableTotal: true,
    //   header: ({ column }) => (
    //     <DataTableColumnHeader column={column} title={t("Report.vat")} />
    //   ),
    //   cell: ({ row: { original: report } }) => {
    //     return <p>{formatIntToCurrency(report.vat, true)}</p>;
    //   },
    // },
  ];

  return (
    <>
      <DataTable
        csvExport={{
          filename,
        }}
        pdfExport={{
          title,
          filename,
        }}
        columns={columns}
        data={data}
      />
    </>
  );
}
